import { vnModule_knockoutJS } from '../../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import { XMLHttpRequestHandler_requestType } from '../../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import { header } from '../header';
import { adminRecruitingQuestions_template } from '../../components/templates/recruiting/adminRecruitingQuestions_template';
import { startListLoading, stopListLoading } from '~/utils/listLoading';
export class admin_recruiting_questions extends vnModule_knockoutJS {
    static getRowsFromResponse(responseParsed) {
        const possibleRows = [
            responseParsed?.data?.paginatedData,
            responseParsed?.paginatedData,
            responseParsed?.beans,
            responseParsed?.data,
        ];
        return possibleRows.find(Array.isArray) || [];
    }
    /**
     * Return the module key used by the Valnet app framework.
     *
     * @return string
     */
    getModuleName() {
        return 'admin_recruiting_questions';
    }
    /**
     * Build and return the DOM content for this module.
     *
     * @return Array<Element>
     */
    buildContent() {
        const zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        const loadedModule = zoneHeader.loadedModule;
        loadedModule.setHeaderTitle('Available Questions');
        this.tpl = new adminRecruitingQuestions_template('adminRecruitingQuestionsTemplate', this.viewModel, this);
        this.template = this.tpl;
        return [this.tpl.build()];
    }
    /**
     * Load the initial data required by the page.
     *
     * @return void
     */
    fillPage() {
        this.updateViewModelFromPath();
        this.getListData();
    }
    /**
     * Return list data.
     *
     * @return void
     */
    getListData() {
        startListLoading(this, this.tpl.builtTemplate);
        this.sendFilterCall('/api/admin/rest/api/lead/recruiting/questions', this.tpl.getViewModelForRequest(), this.onDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getRecruitingQuestions');
    }
    /**
     * Handle the API response for data request.
     *
     * @param req any
     * @param obj any
     * @return () => void
     */
    onDataRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response || '{}');
                const rows = admin_recruiting_questions.getRowsFromResponse(responseParsed);
                const totalCount = Number(responseParsed.totalCount || responseParsed.count || 0);
                const totalPages = Math.max(1, Number(responseParsed.totalPage || Math.ceil(totalCount / 20) || 1));
                const paginationVm = obj.tpl.getPaginationViewModel();
                if (paginationVm && typeof paginationVm.pageNumber === 'function') {
                    paginationVm.pageNumber(Math.max(1, Number(responseParsed.currentPage || paginationVm.pageNumber())));
                }
                obj.validationTemplate.clearMessages();
                obj.tpl.setQuestions(rows);
                obj.tpl.updatePagination(totalCount);
                obj.tpl.setResultInfo(totalCount, totalPages, Math.round((new Date().getTime() - req.requestStartTime) / 1000 * 100) / 100);
            });
            if (req.request.readyState === 4 && req.request.status !== 0) {
                stopListLoading(obj, obj.tpl.builtTemplate);
            }
        };
    }
    /**
     * Handle pagination click events.
     *
     * @return void
     */
    paginationOnPageClick() {
        this.getListData();
    }
    /**
     * Navigate back to question banks.
     *
     * @return void
     */
    backToQuestionBanks() {
        page('/admin/questionBanks');
    }
    /**
     * Navigate to create question.
     *
     * @return void
     */
    createQuestion() {
        page('/admin/recruitingQuestion/new');
    }
    /**
     * Navigate to edit question.
     *
     * @param id number
     * @return void
     */
    editQuestion(id) {
        page('/admin/recruitingQuestion/' + id);
    }
}
